"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
const uuid_1 = require("uuid");
function generateRemovedItem(item, event) {
    var _a, _b, _c;
    item.quantity = Math.abs(event.quantity);
    item.id = event.id;
    if ((_a = item.adjustments) === null || _a === void 0 ? void 0 : _a.length) {
        // remove applied rewards
        item.adjustments = (_b = item.adjustments) === null || _b === void 0 ? void 0 : _b.filter(adj => adj.adjustmentType !== domain_1.AdjustmentType.REWARD);
        // recalculate discount amount after rewards removal
        item.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(item);
    }
    if ((_c = item.comboItems) === null || _c === void 0 ? void 0 : _c.length) {
        item.comboItems = item.comboItems.map(item => {
            item.id = (0, uuid_1.v4)();
            return (0, utils_1.updateRemovedOrderItemDetails)(item, event.reason);
        });
    }
    return (0, utils_1.updateRemovedOrderItemDetails)(item, event.reason);
}
/**
 * Remove rewards from orderItem that got updated
 * @param item the target order item
 */
function handleRemoveRewards(item) {
    var _a;
    (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a.forEach(adj => {
        if (adj.adjustmentType === domain_1.AdjustmentType.REWARD &&
            adj.itemQuantity > item.quantity) {
            // if adjustments itemQuantity greater than actual quantity after update, decrease it
            adj.itemQuantity = item.quantity;
        }
    });
}
/**
 * Updates the quantity of an ORDER ITEM in an order.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type UpdateOrderItemQuantityEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    const orderItem = order.orderItems.find(x => x.id === event.orderItemId);
    if (orderItem === undefined || (orderItem && !(0, utils_1.isItemEditable)(orderItem))) {
        return order;
    }
    orderItem.quantity += event.quantity;
    orderItem.quantity = parseFloat(orderItem.quantity.toFixed(3));
    if (event.quantity < 0) {
        order.orderItems.push(generateRemovedItem((0, utils_1.clone)(orderItem), event));
        handleRemoveRewards(orderItem);
    }
    else {
        order.lastOrderedAt = event.timestamp;
    }
    order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    if (orderItem.adjustments) {
        orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
        orderItem.surchargeAmount = (0, computePrice_1.computeOrderItemSurcharge)(orderItem);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=updateOrderItemQuantity.js.map